@if (status.down()) {
  <div class="backend-down-banner">
    <app-icon class="backend-down-banner__icon" name="triangle-alert" [size]="18" aria-hidden="true" />
    <!-- Solo el texto es región viva: un role="alert" que envuelve controles interactivos expone
         el botón de forma impredecible en lectores de pantalla. -->
    <p class="backend-down-banner__message" role="alert">
      Sin conexión con el servidor. Reintentando automáticamente…
    </p>
    <button
      type="button"
      class="backend-down-banner__retry"
      [disabled]="status.checking()"
      (click)="status.checkNow()"
    >
      @if (status.checking()) {
        <!-- Spinner decorativo: el cambio de texto del botón ya comunica el estado. -->
        <span class="backend-down-banner__spinner" aria-hidden="true"></span>
      }
      {{ status.checking() ? 'Probando…' : 'Probar ahora' }}
    </button>
  </div>
}
